export enum DateRangeOperator {
  Less = "Less",
  LessOrEqual = "LessOrEqual"
}
